import { render, staticRenderFns } from "./TextImage.vue?vue&type=template&id=749504ae&scoped=true"
import script from "./TextImage.vue?vue&type=script&lang=js"
export * from "./TextImage.vue?vue&type=script&lang=js"
import style0 from "./TextImage.vue?vue&type=style&index=0&id=749504ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749504ae",
  null
  
)

export default component.exports